import { useState, useRef } from "react";
import { getCroppedImg } from "./crop-image";

export const useImageState = (
  uploadedFile: any,
  callback: (blob: any) => void,
) => {
  const [apiError, setApiError] = useState(null);
  /* eslint-disable @typescript-eslint/no-unused-vars*/
  const [previewFileData, setPreviewFileData] = uploadedFile;
  const [fileObj, setFileObj] = useState<string>("");
  const [isFileSelect, setIsFileSelect] = useState(false);

  const fileData = {} as {
    previewType: string;
    previewUrl: string | ArrayBuffer | null;
  };

  const inputRef = useRef(null);

  const selectFile = () => {
    if (inputRef.current) {
      (inputRef.current as HTMLInputElement).click();
    }
  };

  const handleFileChange = (event: any) => {
    setIsFileSelect(true);
    const file = event.target.files[0];
    if (file) {
      previewFile(file);
    }
  };

  const previewFile = async (file: any) => {
    fileData.previewType = "image";
    const reader = new FileReader();

    reader.onload = () => {
      if (file.type.startsWith("image/")) {
        fileData.previewUrl = reader.result;
      } else if (file.type.startsWith("video/")) {
        fileData.previewType = "video";
        fileData.previewUrl = URL.createObjectURL(file);
      }
      setFileObj(fileData.previewUrl as string);
    };
    reader.onerror = (error) => {
      console.error(`Error while reading file ${file.name}: ${error}`);
    };
    reader.readAsDataURL(file);
  };

  const handleDroppedFile = async (file: File) => {
    setIsFileSelect(true);
    previewFile(file);
  };

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const file = e.dataTransfer.files[0];
    if (file) {
      handleDroppedFile(file);
    }
  };

  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState();

  const onCropComplete = (_: any, croppedAreaPixels: any) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const cropImage = async () => {
    await getCroppedImg(fileObj, croppedAreaPixels, 0)
      .then(({ blob, dataUrl }: any) => {
        fileData.previewUrl = dataUrl;
        setPreviewFileData(fileData);
        callback(blob);
        setIsFileSelect(false);
      })
      .catch((error) => {
        setApiError(error);
      });
  };

  return {
    inputRef,
    fileObj,
    isFileSelect,
    selectFile,
    handleFileChange,
    crop,
    setCrop,
    zoom,
    setZoom,
    setIsFileSelect,
    onCropComplete,
    cropImage,
    apiError,
    setApiError,
    handleDragOver,
    handleDrop,
  };
};
